import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding: ${(p) => p.theme.spacing(1)};
`;
